import messages from './message-modal-translations';
import * as $ from 'jquery';

export default {
    name: 'instamapsMessageModal',
    i18n: {
        messages,
    },
    props: {
        delay: { type: Number },
        isError: { type: Boolean },
        isLoaded: { type: Boolean },
        title: { type: String, },
        message: { type: String, },
    },
    methods: {
        show: function () {
            setTimeout(function () {
                $('#message-modal').addClass('animate-flex-modal');
            }, (this.delay) ? this.delay : 100);
        },
        dismiss: function () {
            $('#message-modal').removeClass('animate-flex-modal');
            this.$emit('loaded');
        },
    },
    watch: {
        'isLoaded': function(val){
            if(val){
                this.show();
            }
        },
    },
};



// WEBPACK FOOTER //
// ./src/shared/components/message-modal/message-modal.js